(function() {
    // Find all carousel containers
    document.querySelectorAll('.resource-carousel').forEach(function(container) {
        const title = container.dataset.title || 'Popular Resources';
        const highlightWord = container.dataset.highlight || '';
        const items = container.querySelectorAll('.carousel-item');

        if (items.length === 0) return;

        // Build the carousel HTML
        let cardsHTML = '';
        items.forEach(function(item) {
            const image = item.dataset.image || '';
            const cardTitle = item.dataset.title || '';
            const text = item.dataset.text || '';
            const link = item.dataset.link || '#';
            const linkText = item.dataset.linkText || 'View';

            cardsHTML += `
                <a href="${link}" class="resource-card" target="_blank" rel="noopener">
                    ${image ? `<img src="${image}" alt="${cardTitle}" class="resource-card-image" loading="lazy">` : ''}
                    <div class="resource-card-content">
                        <h3 class="resource-card-title">${cardTitle}</h3>
                        <p class="resource-card-text">${text}</p>
                        <span class="resource-card-link">
                            <span>${linkText}</span>
                            <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                        </span>
                    </div>
                </a>
            `;
        });

        // Build dots HTML for mobile (use counter if more than 7 items)
        const useCounter = items.length > 7;
        let dotsHTML = '';
        if (useCounter) {
            dotsHTML = `<span class="carousel-counter">1 / ${items.length}</span>`;
        } else {
            items.forEach(function(_, index) {
                dotsHTML += `<button class="carousel-dot${index === 0 ? ' active' : ''}" data-index="${index}"></button>`;
            });
        }

        // Format title with highlight
        let formattedTitle = title;
        if (highlightWord) {
            formattedTitle = title.replace(highlightWord, `<span>${highlightWord}</span>`);
        }

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'resource-carousel-wrapper';
        wrapper.innerHTML = `
            <div class="resource-carousel-header">
                <h2 class="resource-carousel-title">${formattedTitle}</h2>
                <div class="resource-carousel-nav">
                    <button class="carousel-nav-btn carousel-prev" aria-label="Previous">
                        <svg viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                    </button>
                    <button class="carousel-nav-btn carousel-next" aria-label="Next">
                        <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    </button>
                </div>
            </div>
            <div class="resource-carousel-track-container">
                <div class="resource-carousel-track">
                    ${cardsHTML}
                </div>
            </div>
            <div class="carousel-dots${useCounter ? ' use-counter' : ''}">${dotsHTML}</div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);

        // Initialize carousel functionality
        const track = wrapper.querySelector('.resource-carousel-track');
        const prevBtn = wrapper.querySelector('.carousel-prev');
        const nextBtn = wrapper.querySelector('.carousel-next');
        const dots = wrapper.querySelectorAll('.carousel-dot');
        const counter = wrapper.querySelector('.carousel-counter');
        const trackContainer = wrapper.querySelector('.resource-carousel-track-container');

        let currentIndex = 0;
        const totalItems = items.length;

        // Update counter or dots display
        function updateIndicator() {
            if (useCounter && counter) {
                counter.textContent = `${currentIndex + 1} / ${totalItems}`;
            } else {
                dots.forEach(function(dot, index) {
                    dot.classList.toggle('active', index === currentIndex);
                });
            }
        }

        function getVisibleCards() {
            const width = window.innerWidth;
            if (width <= 640) return 1;
            if (width <= 1024) return 2;
            return 3;
        }

        // Ease-in-out cubic function for smooth acceleration/deceleration
        function easeInOutCubic(t) {
            return t < 0.5
                ? 4 * t * t * t
                : 1 - Math.pow(-2 * t + 2, 3) / 2;
        }

        // Custom smooth animation for desktop transform
        let currentTransform = 0;
        function animateTransform(targetOffset, duration) {
            const startOffset = currentTransform;
            const distance = targetOffset - startOffset;
            let startTime = null;

            function animation(currentTime) {
                if (startTime === null) startTime = currentTime;
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeProgress = easeInOutCubic(progress);

                currentTransform = startOffset + (distance * easeProgress);
                track.style.transform = `translateX(-${currentTransform}%)`;

                if (progress < 1) {
                    requestAnimationFrame(animation);
                }
            }

            requestAnimationFrame(animation);
        }

        function updateCarousel(smooth) {
            const visibleCards = getVisibleCards();
            const maxIndex = Math.max(0, totalItems - visibleCards);
            currentIndex = Math.min(currentIndex, maxIndex);
            currentIndex = Math.max(0, currentIndex);

            // Calculate offset based on card width
            const cardWidthPercent = 100 / visibleCards;
            const targetOffset = currentIndex * cardWidthPercent;

            if (smooth) {
                animateTransform(targetOffset, 700);
            } else {
                currentTransform = targetOffset;
                track.style.transform = `translateX(-${targetOffset}%)`;
            }

            // Update button states
            prevBtn.disabled = currentIndex === 0;
            nextBtn.disabled = currentIndex >= maxIndex;

            // Update dots or counter
            updateIndicator();
        }

        function isMobile() {
            return window.innerWidth <= 640;
        }

        // Custom smooth scroll for mobile
        function smoothScrollTo(element, targetPosition, duration) {
            const startPosition = element.scrollLeft;
            const distance = targetPosition - startPosition;
            let startTime = null;

            function animation(currentTime) {
                if (startTime === null) startTime = currentTime;
                const elapsed = currentTime - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeProgress = easeInOutCubic(progress);

                element.scrollLeft = startPosition + (distance * easeProgress);

                if (progress < 1) {
                    requestAnimationFrame(animation);
                }
            }

            requestAnimationFrame(animation);
        }

        function scrollToCard(index) {
            const cards = track.querySelectorAll('.resource-card');
            if (cards[index]) {
                // Get the current scroll position
                const currentScroll = trackContainer.scrollLeft;

                // Calculate one card width including gap
                const cardWidth = cards[0].offsetWidth;
                const gap = 20; // margin between cards
                const scrollIncrement = cardWidth + gap;

                // Calculate target based on direction from current position
                // For index 0, go to start
                if (index === 0) {
                    smoothScrollTo(trackContainer, 0, 500);
                } else {
                    // Scroll by one card increment from current position
                    const targetScroll = index * scrollIncrement;
                    smoothScrollTo(trackContainer, targetScroll, 500);
                }
            }
        }

        prevBtn.addEventListener('click', function() {
            if (currentIndex > 0) {
                // Move by 2 cards on desktop/tablet, 1 on mobile
                const step = isMobile() ? 1 : 2;
                currentIndex = Math.max(0, currentIndex - step);
                if (isMobile()) {
                    // Scroll by one card width using native smooth scroll
                    const cards = track.querySelectorAll('.resource-card');
                    const cardWidth = cards[0].offsetWidth;
                    const gap = 20;
                    const scrollIncrement = cardWidth + gap;
                    const targetScroll = Math.max(0, trackContainer.scrollLeft - scrollIncrement);
                    trackContainer.scrollTo({
                        left: targetScroll,
                        behavior: 'smooth'
                    });
                } else {
                    updateCarousel(true);
                }
                // Update indicator and button states
                updateIndicator();
                const maxIndex = isMobile() ? totalItems - 1 : Math.max(0, totalItems - getVisibleCards());
                prevBtn.disabled = currentIndex === 0;
                nextBtn.disabled = currentIndex >= maxIndex;
            }
        });

        nextBtn.addEventListener('click', function() {
            // On mobile, maxIndex is totalItems - 1 (can go to last card)
            // On desktop/tablet, maxIndex is totalItems - visibleCards
            const maxIndex = isMobile() ? totalItems - 1 : Math.max(0, totalItems - getVisibleCards());
            if (currentIndex < maxIndex) {
                // Move by 2 cards on desktop/tablet, 1 on mobile
                const step = isMobile() ? 1 : 2;
                currentIndex = Math.min(maxIndex, currentIndex + step);
                if (isMobile()) {
                    // Scroll by one card width using native smooth scroll
                    const cards = track.querySelectorAll('.resource-card');
                    const cardWidth = cards[0].offsetWidth;
                    const gap = 20;
                    const scrollIncrement = cardWidth + gap;
                    const maxScroll = trackContainer.scrollWidth - trackContainer.offsetWidth;
                    const targetScroll = Math.min(maxScroll, trackContainer.scrollLeft + scrollIncrement);
                    trackContainer.scrollTo({
                        left: targetScroll,
                        behavior: 'smooth'
                    });
                } else {
                    updateCarousel(true);
                }
                // Update indicator and button states
                updateIndicator();
                prevBtn.disabled = currentIndex === 0;
                nextBtn.disabled = currentIndex >= maxIndex;
            }
        });

        // Dot click handlers (only when not using counter)
        if (!useCounter) {
            dots.forEach(function(dot) {
                dot.addEventListener('click', function() {
                    currentIndex = parseInt(this.dataset.index);
                    if (isMobile()) {
                        scrollToCard(currentIndex);
                    } else {
                        updateCarousel(true);
                    }
                    // Update indicator and button states
                    updateIndicator();
                    prevBtn.disabled = currentIndex === 0;
                    nextBtn.disabled = currentIndex >= totalItems - 1;
                });
            });
        }

        /* NOTE: Mobile swipe/scroll handling disabled - was causing issues
        // Mobile swipe/scroll handling
        let scrollTimeout;
        trackContainer.addEventListener('scroll', function() {
            if (!isMobile()) return;
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(function() {
                const cards = track.querySelectorAll('.resource-card');
                const containerCenter = trackContainer.scrollLeft + trackContainer.offsetWidth / 2;
                let closestIndex = 0;
                let closestDistance = Infinity;
                cards.forEach(function(card, index) {
                    const cardCenter = card.offsetLeft + card.offsetWidth / 2;
                    const distance = Math.abs(containerCenter - cardCenter);
                    if (distance < closestDistance) {
                        closestDistance = distance;
                        closestIndex = index;
                    }
                });
                if (closestIndex !== currentIndex) {
                    currentIndex = closestIndex;
                    updateIndicator();
                    prevBtn.disabled = currentIndex === 0;
                    nextBtn.disabled = currentIndex >= totalItems - 1;
                }
            }, 50);
        });
        END OF DISABLED MOBILE SWIPE FUNCTIONALITY */

        /* NOTE: Drag-to-scroll functionality disabled - was causing issues
        // Drag to scroll functionality (desktop and mobile)
        let isDragging = false;
        let startX = 0;
        let startTransform = 0;
        let hasDragged = false;
        const dragThreshold = 5;

        // Prevent default drag behavior on images
        track.querySelectorAll('img').forEach(function(img) {
            img.setAttribute('draggable', 'false');
        });

        // Mouse events for desktop drag
        trackContainer.addEventListener('mousedown', function(e) {
            if (isMobile()) return;
            isDragging = true;
            hasDragged = false;
            startX = e.pageX;
            startTransform = currentTransform;
            trackContainer.style.cursor = 'grabbing';
            document.body.style.userSelect = 'none';
            e.preventDefault();
        });

        document.addEventListener('mousemove', function(e) {
            if (!isDragging || isMobile()) return;

            const x = e.pageX;
            const walk = startX - x;

            if (Math.abs(walk) > dragThreshold) {
                hasDragged = true;
            }

            // Calculate drag as percentage of container width
            const containerWidth = trackContainer.offsetWidth;
            const dragPercent = (walk / containerWidth) * 100;
            const newTransform = startTransform + dragPercent;

            // Clamp the transform value
            const visibleCards = getVisibleCards();
            const maxTransform = ((totalItems - visibleCards) / visibleCards) * 100;
            currentTransform = Math.max(0, Math.min(newTransform, maxTransform));
            track.style.transform = `translateX(-${currentTransform}%)`;
        });

        document.addEventListener('mouseup', function() {
            if (!isDragging || isMobile()) return;
            isDragging = false;
            trackContainer.style.cursor = 'grab';
            document.body.style.userSelect = '';

            if (hasDragged) {
                // Snap to nearest card
                const visibleCards = getVisibleCards();
                const cardWidthPercent = 100 / visibleCards;
                const newIndex = Math.round(currentTransform / cardWidthPercent);
                const maxIndex = Math.max(0, totalItems - visibleCards);
                currentIndex = Math.max(0, Math.min(newIndex, maxIndex));
                updateCarousel(true);
            }
        });

        // Prevent click on cards when dragging
        track.querySelectorAll('.resource-card').forEach(function(card) {
            card.addEventListener('click', function(e) {
                if (hasDragged) {
                    e.preventDefault();
                    e.stopPropagation();
                    hasDragged = false;
                }
            });
        });

        // Touch events for tablet drag (mobile uses native scroll)
        trackContainer.addEventListener('touchstart', function(e) {
            if (isMobile()) return;
            isDragging = true;
            hasDragged = false;
            startX = e.touches[0].pageX;
            startTransform = currentTransform;
        }, { passive: true });

        trackContainer.addEventListener('touchmove', function(e) {
            if (isMobile() || !isDragging) return;

            const x = e.touches[0].pageX;
            const walk = startX - x;

            if (Math.abs(walk) > dragThreshold) {
                hasDragged = true;
            }

            const containerWidth = trackContainer.offsetWidth;
            const dragPercent = (walk / containerWidth) * 100;
            const newTransform = startTransform + dragPercent;

            const visibleCards = getVisibleCards();
            const maxTransform = ((totalItems - visibleCards) / visibleCards) * 100;
            currentTransform = Math.max(0, Math.min(newTransform, maxTransform));
            track.style.transform = `translateX(-${currentTransform}%)`;
        }, { passive: true });

        trackContainer.addEventListener('touchend', function() {
            if (isMobile() || !isDragging) return;
            isDragging = false;

            if (hasDragged) {
                const visibleCards = getVisibleCards();
                const cardWidthPercent = 100 / visibleCards;
                const newIndex = Math.round(currentTransform / cardWidthPercent);
                const maxIndex = Math.max(0, totalItems - visibleCards);
                currentIndex = Math.max(0, Math.min(newIndex, maxIndex));
                updateCarousel(true);
            }
        });

        // Set initial cursor style for desktop
        if (!isMobile()) {
            trackContainer.style.cursor = 'grab';
        } else {
            // Reset scroll position to start on mobile
            trackContainer.scrollLeft = 0;
        }
        END OF DISABLED DRAG FUNCTIONALITY */

        // Reset scroll position on mobile
        if (isMobile()) {
            trackContainer.scrollLeft = 0;
        }

        // Handle resize
        window.addEventListener('resize', function() {
            updateCarousel();
        });

        // Initial setup
        updateCarousel();
    });
})();

(function() {
    // Find all hero intro containers
    document.querySelectorAll('.hero-intro-container').forEach(function(container) {
        const image = container.dataset.image || '';
        const alt = container.dataset.alt || '';
        const title = container.dataset.title || '';
        const text = container.dataset.text || '';

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'hero-intro-wrapper';
        wrapper.innerHTML = `
            <div class="hero-intro">
                ${image ? `
                    <a href="/about" class="hero-intro-image-container">
                        <img src="${image}" alt="${alt}" class="hero-intro-image" loading="lazy">
                    </a>
                ` : ''}
                <div class="hero-intro-content">
                    ${title ? `<h1 class="hero-intro-title">${title}</h1>` : ''}
                    ${text ? `<p class="hero-intro-text">${text}</p>` : ''}
                </div>
            </div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    // Find all help grid containers
    document.querySelectorAll('.help-grid-container').forEach(function(container) {
        const title = container.dataset.title || 'How Can I Help You?';
        const highlight = container.dataset.highlight || '';
        const items = container.querySelectorAll('.help-item');

        if (items.length === 0) return;

        // Process title with highlight
        let titleHTML = title;
        if (highlight && title.includes(highlight)) {
            titleHTML = title.replace(highlight, `<span class="help-grid-title-highlight">${highlight}</span>`);
        }

        // Separate items into left and right columns (masonry style)
        const leftItems = [];
        const rightItems = [];
        items.forEach(function(item, index) {
            if (index % 2 === 0) {
                leftItems.push(item);
            } else {
                rightItems.push(item);
            }
        });

        // Build card HTML
        function buildCard(item) {
            const emoji = item.dataset.emoji || '';
            const icon = item.dataset.icon || '';
            const cardTitle = item.dataset.title || '';
            const text = item.dataset.text || '';
            const link = item.dataset.link || '#';
            const linkText = item.dataset.linkText || 'Get started';
            const isMinimal = !emoji && !icon && !text;

            if (isMinimal) {
                return `
                    <a href="${link}" class="help-grid-card-minimal">
                        <h3 class="help-grid-card-title">${cardTitle}</h3>
                        <span class="help-grid-card-link"><span>${linkText}</span></span>
                    </a>
                `;
            }

            // Build icon/emoji HTML
            let iconHTML = '';
            if (icon) {
                iconHTML = `<img src="${icon}" alt="${cardTitle}" class="help-grid-svg-icon" loading="lazy">`;
            } else if (emoji) {
                iconHTML = `<span class="help-grid-emoji">${emoji}</span>`;
            }

            return `
                <a href="${link}" class="help-grid-card">
                    ${iconHTML}
                    ${cardTitle ? `<h3 class="help-grid-card-title">${cardTitle}</h3>` : ''}
                    ${text ? `<p class="help-grid-card-text">${text}</p>` : ''}
                    <span class="help-grid-card-link"><span>${linkText}</span></span>
                </a>
            `;
        }

        // Build columns HTML
        let leftColumnHTML = '';
        leftItems.forEach(function(item) {
            leftColumnHTML += buildCard(item);
        });

        let rightColumnHTML = '';
        rightItems.forEach(function(item) {
            rightColumnHTML += buildCard(item);
        });

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'help-grid-wrapper';
        wrapper.innerHTML = `
            <div class="help-grid-header">
                <h2 class="help-grid-title">${titleHTML}</h2>
            </div>
            <div class="help-grid-container">
                <div class="help-grid-column">${leftColumnHTML}</div>
                <div class="help-grid-column">${rightColumnHTML}</div>
            </div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    // Find all app promo containers
    document.querySelectorAll('.app-promo-container').forEach(function(container) {
        const image = container.dataset.image || '';
        const title = container.dataset.title || '';
        const text = container.dataset.text || '';
        const buttonText = container.dataset.buttonText || 'Get Started';
        const buttonLink = container.dataset.buttonLink || '#';
        const note = container.dataset.note || '';

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'app-promo-wrapper';
        wrapper.innerHTML = `
            <div class="app-promo">
                ${image ? `
                    <a href="${buttonLink}" class="app-promo-image-container">
                        <img src="${image}" alt="" class="app-promo-image" loading="lazy">
                    </a>
                ` : ''}
                <div class="app-promo-content">
                    ${title ? `<h2 class="app-promo-title">${title}</h2>` : ''}
                    ${text ? `<p class="app-promo-text">${text}</p>` : ''}
                    <div class="app-promo-cta">
                        <a href="${buttonLink}" class="app-promo-button">${buttonText}</a>
                        ${note ? `<p class="app-promo-note">${note}</p>` : ''}
                    </div>
                </div>
            </div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    // Find all emoji grid containers
    document.querySelectorAll('.emoji-grid-container').forEach(function(container) {
        const items = container.querySelectorAll('.grid-item');

        if (items.length === 0) return;

        // Build the grid HTML
        let gridHTML = '';
        items.forEach(function(item) {
            const emoji = item.dataset.emoji || '';
            const text = item.dataset.text || '';
            const link = item.dataset.link || '#';

            gridHTML += `
                <a href="${link}" class="emoji-grid-item" target="_blank" rel="noopener">
                    <span class="emoji-grid-emoji">${emoji}</span>
                    <span class="emoji-grid-text">${text}</span>
                </a>
            `;
        });

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'emoji-grid-wrapper';
        wrapper.innerHTML = `
            <div class="emoji-grid">
                ${gridHTML}
            </div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    // Find all product grid containers
    document.querySelectorAll('.product-grid-container').forEach(function(container) {
        const items = container.querySelectorAll('.product-item');
        const isWide = container.hasAttribute('data-wide');

        if (items.length === 0) return;

        // Build items HTML
        let itemsHTML = '';
        items.forEach(function(item) {
            const image = item.dataset.image || '';
            const title = item.dataset.title || '';
            const text = item.dataset.text || '';
            const link = item.dataset.link || '#';

            itemsHTML += `
                <a href="${link}" class="product-grid-item" target="_blank" rel="noopener">
                    <div class="product-grid-image-container">
                        ${image ? `<img src="${image}" alt="${title}" class="product-grid-image" loading="lazy">` : ''}
                    </div>
                    ${title ? `<h3 class="product-grid-title">${title}</h3>` : ''}
                    ${text ? `<p class="product-grid-text">${text}</p>` : ''}
                </a>
            `;
        });

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'product-grid-wrapper' + (isWide ? ' wide' : '');
        wrapper.innerHTML = `
            <div class="product-grid">
                ${itemsHTML}
            </div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    // Find all book promo containers
    document.querySelectorAll('.book-promo-container').forEach(function(container) {
        const title = container.dataset.title || '';
        const tagline = container.dataset.tagline || '';
        const image = container.dataset.image || '';
        const buttonText = container.dataset.buttonText || 'Get the Book!';
        const buttonLink = container.dataset.buttonLink || '#';
        const secondaryText = container.dataset.secondaryText || '';
        const secondaryLink = container.dataset.secondaryLink || '';
        const secondaryLinkText = container.dataset.secondaryLinkText || 'here';

        // Get all paragraph texts
        const textItems = container.querySelectorAll('.promo-text');
        let textsHTML = '';
        textItems.forEach(function(item) {
            textsHTML += `<p class="book-promo-text">${item.dataset.text || ''}</p>`;
        });

        // Build secondary link HTML if provided
        let secondaryHTML = '';
        if (secondaryText && secondaryLink) {
            secondaryHTML = `
                <p class="book-promo-secondary-link">
                    ${secondaryText} <a href="${secondaryLink}" target="_blank" rel="noopener">${secondaryLinkText}</a>!
                </p>
            `;
        }

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'book-promo-wrapper';
        wrapper.innerHTML = `
            <div class="book-promo">
                ${title ? `<h2 class="book-promo-title">${title}</h2>` : ''}
                <div class="book-promo-body">
                    <div class="book-promo-content">
                        ${tagline ? `<p class="book-promo-tagline">${tagline}</p>` : ''}
                        ${textsHTML}
                        <a href="${buttonLink}" class="book-promo-btn" target="_blank" rel="noopener">${buttonText}</a>
                        ${secondaryHTML}
                    </div>
                    ${image ? `
                        <div class="book-promo-image-container">
                            <img src="${image}" alt="${title}" class="book-promo-image" loading="lazy">
                        </div>
                    ` : ''}
                </div>
            </div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    // Find all article grid containers
    document.querySelectorAll('.article-grid-container').forEach(function(container) {
        const title = container.dataset.title || '';
        const highlightWord = container.dataset.highlight || '';
        const desktopPerPage = parseInt(container.dataset.perPage) || 6;
        const mobilePerPage = parseInt(container.dataset.mobilePerPage) || 1;
        const isWide = container.hasAttribute('data-wide');
        const items = container.querySelectorAll('.article-item');

        if (items.length === 0) return;

        // Collect all article data
        const articles = [];
        items.forEach(function(item) {
            articles.push({
                image: item.dataset.image || '',
                title: item.dataset.title || '',
                date: item.dataset.date || '',
                excerpt: item.dataset.excerpt || '',
                link: item.dataset.link || '#'
            });
        });

        // Get items per page based on screen size
        function getItemsPerPage() {
            return window.innerWidth <= 600 ? mobilePerPage : desktopPerPage;
        }

        let itemsPerPage = getItemsPerPage();
        let totalPages = Math.ceil(articles.length / itemsPerPage);
        let currentPage = 1;

        // Format title with highlight
        let formattedTitle = title;
        if (highlightWord && title) {
            formattedTitle = title.replace(highlightWord, `<span>${highlightWord}</span>`);
        }

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'article-grid-wrapper' + (isWide ? ' wide' : '');

        // Build initial HTML structure
        wrapper.innerHTML = `
            ${formattedTitle ? `<h2 class="article-grid-title">${formattedTitle}</h2>` : ''}
            <div class="article-grid"></div>
            <div class="article-grid-pagination"></div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);

        const gridEl = wrapper.querySelector('.article-grid');
        const paginationEl = wrapper.querySelector('.article-grid-pagination');

        // Render articles for current page
        function renderArticles() {
            const start = (currentPage - 1) * itemsPerPage;
            const end = start + itemsPerPage;
            const pageArticles = articles.slice(start, end);

            let cardsHTML = '';
            pageArticles.forEach(function(article) {
                cardsHTML += `
                    <div class="article-grid-card">
                        <a href="${article.link}">
                            ${article.image ? `
                                <div class="article-grid-image-container">
                                    <img src="${article.image}" alt="${article.title}" class="article-grid-image" loading="lazy">
                                </div>
                            ` : ''}
                            <div class="article-grid-content">
                                <h3 class="article-grid-card-title">${article.title}</h3>
                                ${article.date ? `<p class="article-grid-date">${article.date}</p>` : ''}
                                ${article.excerpt ? `<p class="article-grid-excerpt">${article.excerpt}</p>` : ''}
                                <span class="article-grid-link">
                                    Continue Reading
                                    <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                                </span>
                            </div>
                        </a>
                    </div>
                `;
            });

            gridEl.innerHTML = cardsHTML;
        }

        // Render pagination
        function renderPagination() {
            if (totalPages <= 1) {
                paginationEl.style.display = 'none';
                return;
            }

            const isMobile = window.innerWidth <= 600;
            let paginationHTML = `
                <button class="prev-btn" ${currentPage === 1 ? 'disabled' : ''}>←${isMobile ? '' : ' Previous'}</button>
                <div class="page-numbers">
            `;

            // Generate page numbers with ellipsis
            const maxVisible = 7;
            let pages = [];

            if (totalPages <= maxVisible) {
                for (let i = 1; i <= totalPages; i++) {
                    pages.push(i);
                }
            } else {
                if (currentPage <= 4) {
                    pages = [1, 2, 3, 4, 5, '...', totalPages];
                } else if (currentPage >= totalPages - 3) {
                    pages = [1, '...', totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
                } else {
                    pages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', totalPages];
                }
            }

            pages.forEach(function(page) {
                if (page === '...') {
                    paginationHTML += `<span class="page-ellipsis">...</span>`;
                } else {
                    paginationHTML += `<button class="page-btn${page === currentPage ? ' active' : ''}" data-page="${page}">${page}</button>`;
                }
            });

            paginationHTML += `
                </div>
                <button class="next-btn" ${currentPage === totalPages ? 'disabled' : ''}>${isMobile ? '' : 'Next '}→</button>
            `;

            paginationEl.innerHTML = paginationHTML;
        }

        // Event handlers
        paginationEl.addEventListener('click', function(e) {
            const target = e.target;

            if (target.classList.contains('prev-btn') && currentPage > 1) {
                currentPage--;
                renderArticles();
                renderPagination();
                wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (target.classList.contains('next-btn') && currentPage < totalPages) {
                currentPage++;
                renderArticles();
                renderPagination();
                wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
            } else if (target.classList.contains('page-btn')) {
                const page = parseInt(target.dataset.page);
                if (page !== currentPage) {
                    currentPage = page;
                    renderArticles();
                    renderPagination();
                    wrapper.scrollIntoView({ behavior: 'smooth', block: 'start' });
                }
            }
        });

        // Initial render
        renderArticles();
        renderPagination();

        // Handle resize for responsive items per page
        let resizeTimeout;
        window.addEventListener('resize', function() {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(function() {
                const newItemsPerPage = getItemsPerPage();
                if (newItemsPerPage !== itemsPerPage) {
                    itemsPerPage = newItemsPerPage;
                    totalPages = Math.ceil(articles.length / itemsPerPage);
                    currentPage = 1;
                    renderArticles();
                    renderPagination();
                }
            }, 150);
        });
    });
})();

(function() {
    document.querySelectorAll('.shorts-carousel').forEach(function(container) {
        const title = container.dataset.title || 'YouTube Shorts';
        const highlightWord = container.dataset.highlight || '';
        const items = container.querySelectorAll('.shorts-item');

        if (items.length === 0) return;

        // Build cards HTML
        let cardsHTML = '';
        items.forEach(function(item) {
            const image = item.dataset.image || '';
            const cardTitle = item.dataset.title || '';
            const link = item.dataset.link || '#';

            cardsHTML += `
                <a href="${link}" class="shorts-card" target="_blank" rel="noopener">
                    <div class="shorts-card-image-container">
                        ${image ? `<img src="${image}" alt="${cardTitle}" class="shorts-card-image" loading="lazy">` : ''}
                    </div>
                    <h3 class="shorts-card-title">${cardTitle}</h3>
                </a>
            `;
        });

        // Format title with highlight
        let formattedTitle = title;
        if (highlightWord) {
            formattedTitle = title.replace(highlightWord, `<span>${highlightWord}</span>`);
        }

        // Build dots HTML
        const visibleCards = window.innerWidth <= 600 ? 2 : (window.innerWidth <= 900 ? 3 : 5);
        const totalDots = Math.ceil(items.length / visibleCards);
        let dotsHTML = '';
        for (let i = 0; i < totalDots; i++) {
            dotsHTML += `<button class="carousel-dot${i === 0 ? ' active' : ''}" data-index="${i}"></button>`;
        }

        // Create wrapper
        const wrapper = document.createElement('div');
        wrapper.className = 'shorts-carousel-wrapper';
        wrapper.innerHTML = `
            <div class="shorts-carousel-header">
                <h2 class="shorts-carousel-title">${formattedTitle}</h2>
                <div class="shorts-carousel-nav">
                    <button class="carousel-nav-btn carousel-prev" aria-label="Previous">
                        <svg viewBox="0 0 24 24"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
                    </button>
                    <button class="carousel-nav-btn carousel-next" aria-label="Next">
                        <svg viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7"/></svg>
                    </button>
                </div>
            </div>
            <div class="shorts-carousel-track-container">
                <div class="shorts-carousel-track">
                    ${cardsHTML}
                </div>
            </div>
            <div class="shorts-carousel-dots">${dotsHTML}</div>
        `;

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);

        // Initialize carousel functionality
        const track = wrapper.querySelector('.shorts-carousel-track');
        const prevBtn = wrapper.querySelector('.carousel-prev');
        const nextBtn = wrapper.querySelector('.carousel-next');
        const dots = wrapper.querySelectorAll('.carousel-dot');
        const cards = wrapper.querySelectorAll('.shorts-card');
        let currentIndex = 0;

        function getCardWidth() {
            if (cards.length === 0) return 200;
            return cards[0].offsetWidth + 20; // card width + gap
        }

        function getVisibleCards() {
            const containerWidth = wrapper.querySelector('.shorts-carousel-track-container').offsetWidth;
            return Math.floor(containerWidth / getCardWidth());
        }

        function updateCarousel() {
            const cardWidth = getCardWidth();
            track.style.transform = `translateX(-${currentIndex * cardWidth}px)`;

            dots.forEach(function(dot, index) {
                dot.classList.toggle('active', index === Math.floor(currentIndex / getVisibleCards()));
            });
        }

        function scrollNext() {
            const maxIndex = cards.length - getVisibleCards();
            if (currentIndex < maxIndex) {
                currentIndex = Math.min(currentIndex + getVisibleCards(), maxIndex);
                updateCarousel();
            }
        }

        function scrollPrev() {
            if (currentIndex > 0) {
                currentIndex = Math.max(currentIndex - getVisibleCards(), 0);
                updateCarousel();
            }
        }

        prevBtn.addEventListener('click', scrollPrev);
        nextBtn.addEventListener('click', scrollNext);

        dots.forEach(function(dot) {
            dot.addEventListener('click', function() {
                const index = parseInt(this.dataset.index);
                currentIndex = index * getVisibleCards();
                updateCarousel();
            });
        });

        // Handle touch/scroll on mobile
        let isScrolling = false;
        track.addEventListener('scroll', function() {
            if (!isScrolling) {
                isScrolling = true;
                setTimeout(function() {
                    const scrollLeft = track.scrollLeft;
                    const cardWidth = getCardWidth();
                    currentIndex = Math.round(scrollLeft / cardWidth);
                    dots.forEach(function(dot, index) {
                        dot.classList.toggle('active', index === Math.floor(currentIndex / getVisibleCards()));
                    });
                    isScrolling = false;
                }, 100);
            }
        });
    });
})();

(function() {
    var starSVG = '<svg viewBox="0 0 20 20" fill="#d4a017" xmlns="http://www.w3.org/2000/svg"><path d="M10 1.5l2.47 5.01 5.53.8-4 3.9.94 5.49L10 14.26 5.06 16.7 6 11.21l-4-3.9 5.53-.8L10 1.5z"/></svg>';

    document.querySelectorAll('.email-signup-container').forEach(function(container) {
        var title = container.dataset.title || 'Subscribe to the Newsletter';
        var subtitle = container.dataset.text || '';
        var description = container.dataset.description || '';
        var placeholder = container.dataset.placeholder || 'Your email';
        var buttonText = container.dataset.buttonText || 'Subscribe';
        var note = container.dataset.note || '';
        var bg = container.dataset.bg || 'light';
        var layout = container.dataset.layout || '';
        var highlight = container.dataset.highlight || '';
        var successMsg = container.dataset.success || 'Check your inbox for a confirmation email!';
        var avatar = container.dataset.avatar || '';
        var reviewText = container.dataset.reviewText || '';

        // Process title with highlight
        var titleHTML = title;
        if (highlight && title.includes(highlight)) {
            titleHTML = title.replace(
                highlight,
                '<span class="email-signup-title-highlight">' + highlight + '</span>'
            );
        }

        // Build social proof HTML (avatars + stars + review text)
        var socialProofHTML = '';
        if (avatar || reviewText) {
            var avatarsHTML = '';
            if (avatar) {
                avatarsHTML = '<img class="email-signup-avatars" src="' + avatar + '" alt="Readers" loading="lazy">';
            }
            var starsHTML = '<div class="email-signup-stars">';
            for (var s = 0; s < 5; s++) { starsHTML += starSVG; }
            starsHTML += '</div>';

            socialProofHTML = '<div class="email-signup-social-proof">' +
                avatarsHTML +
                '<div class="email-signup-rating">' +
                    starsHTML +
                    (reviewText ? '<span class="email-signup-review-text">' + reviewText + '</span>' : '') +
                '</div>' +
            '</div>';
        }

        // Create wrapper
        var wrapper = document.createElement('div');
        wrapper.className = 'email-signup-wrapper' + (layout === 'compact' ? ' compact' : '');
        if (bg !== 'light') {
            wrapper.setAttribute('data-bg', bg);
        }

        wrapper.innerHTML =
            '<div class="email-signup">' +
                '<div class="email-signup-content">' +
                    (titleHTML ? '<h2 class="email-signup-title">' + titleHTML + '</h2>' : '') +
                    (subtitle ? '<p class="email-signup-subtitle">' + subtitle + '</p>' : '') +
                    socialProofHTML +
                '</div>' +
                '<div class="email-signup-form-side">' +
                    (description ? '<p class="email-signup-description">' + description + '</p>' : '') +
                    '<form class="email-signup-form" data-members-form="subscribe">' +
                        '<div class="email-signup-input-row">' +
                            '<input data-members-email type="email" class="email-signup-input" placeholder="' + placeholder + '" required aria-label="Email address">' +
                            '<button type="submit" class="email-signup-button">' + buttonText + '</button>' +
                        '</div>' +
                        '<p class="email-signup-message loading">Sending...</p>' +
                        '<p class="email-signup-message success">' + successMsg + '</p>' +
                        '<p class="email-signup-message error">Something went wrong. Please try again.</p>' +
                        (note ? '<p class="email-signup-note">' + note + '</p>' : '') +
                    '</form>' +
                '</div>' +
            '</div>';

        // Replace original container
        container.parentNode.replaceChild(wrapper, container);
    });
})();

(function() {
    document.querySelectorAll('.supply-cta-container').forEach(function(container) {
        var heading = container.dataset.heading || 'Want to practice this?';
        var text = container.dataset.text || 'Apply these concepts with interactive exercises and quizzes on Supply Science.';
        var buttonText = container.dataset.buttonText || 'Start Learning for Free';
        var link = container.dataset.link || 'https://supply-science.com';
        var page = container.dataset.page || '';
        var url = page ? link + '/' + page : link;

        // Tag supply-science.com CTAs so the app's analytics can attribute them
        if (url.indexOf('supply-science.com') !== -1 && url.indexOf('utm_source=') === -1) {
            url += (url.indexOf('?') === -1 ? '?' : '&') +
                'utm_source=samirsaci.com&utm_medium=blog&utm_campaign=supply-cta';
        }

        var cta = document.createElement('div');
        cta.className = 'supply-cta';
        cta.innerHTML =
            '<p class="supply-cta-heading">' + heading + '</p>' +
            '<p class="supply-cta-text">' + text + '</p>' +
            '<a href="' + url + '" target="_blank" rel="noopener" class="supply-cta-button">' + buttonText + ' &rarr;</a>';

        container.parentNode.replaceChild(cta, container);
    });
})();
